import React, { forwardRef, HTMLAttributes, ReactNode, useEffect, useRef, useState } from 'react'
import styles from './InfiniteScroll.module.scss'
import clsx from 'clsx'
import composeRefs from '@seznam/compose-react-refs'

interface Props extends HTMLAttributes<HTMLDivElement>{
    children: ReactNode,
    onReach?: () => void,
    reversed?: boolean,
    offset?: number,
}

const InfiniteScroll = forwardRef<HTMLDivElement, Props>((
    { className, children, onReach, offset, reversed, ...props },
    ref
) => {
    const localRef = useRef<HTMLDivElement>(null)

    const [reach, setReach] = useState(false)
    const [size, setSize] = useState(0)

    useEffect(() => {
        if (localRef.current) {
            setSize(localRef.current.scrollHeight)
        }
    }, [children])

    return <div
        ref={composeRefs(localRef, ref)}
        {...props}
        className={clsx(className, styles.container)}
        onScroll={() => {
            if (localRef.current && size > 0) {
                const { scrollHeight, clientHeight, scrollTop } = localRef.current
                if (reversed) {
                    if (scrollTop <= (offset || clientHeight)) {
                        !reach && onReach?.()
                        setReach(true)
                    } else {
                        setReach(false)
                    }
                } else {
                    if ((scrollHeight - scrollTop - clientHeight) <= (offset || clientHeight)) {
                        !reach && onReach?.()
                        setReach(true)
                    } else {
                        setReach(false)
                    }
                }
            }
        }}
    >
        {children}
    </div>
})

InfiniteScroll.displayName = 'InfiniteScroll'

export default InfiniteScroll